import { SxProps, Theme } from '@mui/material';
import { Colors, flexColumn, flexRow } from '@sweatpals/react-ui-kit';
import { CSSProperties } from 'react';

export const perkCardRoot: SxProps<Theme> = flexColumn({
	gap: 1,
	borderRadius: '8px',
	p: '22px 18px',
	border: `2px solid ${Colors['313131']}`,
	background: Colors['171717'],
	position: 'relative',
	width: { xs: '100%', sm: '380px' },
	minHeight: '247px',
});

export const perkCardHeader: SxProps<Theme> = flexRow({ gap: 3, alignItems: 'center' });

export const perkCardAvatar = (url?: string): SxProps<Theme> => ({
	borderRadius: '50%',
	width: '80px',
	height: '80px',
	backgroundImage: url ? `url(${url})` : undefined,
	backgroundSize: 'cover',
	backgroundPosition: 'center',
	backgroundRepeat: 'no-repeat',
	border: `1px solid ${Colors.white_a10}`,
});

export const perkCardTitle: SxProps<Theme> = {
	display: '-webkit-box',
	WebkitBoxOrient: 'vertical',
	WebkitLineClamp: 1,
	flex: '1 0 0',
	color: Colors.white,
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	fontFamily: 'Montserrat',
	fontSize: '17px',
	fontWeight: 700,
};

export const perkCardContent: SxProps<Theme> = flexColumn({ gap: 2, alignItems: 'flex-start', flexGrow: 1 });

export const perkCardDescription: SxProps<Theme> = {
	fontFamily: 'Montserrat',
	color: Colors.white_a80,
	fontSize: '14px',
	fontWeight: 500,
	lineHeight: '1.3em',
	display: '-webkit-box',
	WebkitBoxOrient: 'vertical',
	WebkitLineClamp: 3,
	overflow: 'hidden',
	textOverflow: 'ellipsis',
};

export const perkCardButton: SxProps<Theme> = {
	borderRadius: '100px',
	border: `1px solid ${Colors.white_a10}`,
	background: Colors['343434'],
	p: '10px 12px',
	color: Colors.white,
	fontFamily: 'Montserrat',
	fontSize: '13px',
	fontWeight: 700,
	textTransform: 'none',
	lineHeight: '16px',
};

export const blurredPerkContent: SxProps<Theme> = {
	position: 'absolute',
	top: 0,
	bottom: 0,
	left: 0,
	right: 0,
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	justifyContent: 'center',
	textAlign: 'center',
	gap: '20px',
	px: '31px',
	backdropFilter: 'blur(10px)',
	borderRadius: '8px',
};

export const avatarRow: SxProps<Theme> = flexRow({ gap: '6px', alignItems: 'center' });

export const lockIconStyles: CSSProperties = {
	color: Colors['C5C5C5'],
	width: '26px',
	height: '26px',
};

export const avatarStyles: SxProps<Theme> = {
	width: '32px',
	height: '32px',
	border: Colors.white_a10,
};

export const avatarCounterStyles: SxProps<Theme> = {
	width: 'auto',
	height: '36px',
	boxSizing: 'border-box !important',
	backgroundColor: Colors['343434'],
	borderRadius: '16px',
	color: Colors.white,
	fontFamily: 'Hind',
	borderColor: Colors.transparent,
	fontSize: '15px',
	lineHeight: '1em',
	fontWeight: '500',
	padding: '5px 10px',
};

export const membershipPromoteText: SxProps<Theme> = {
	fontFamily: 'Montserrat',
	fontSize: '14px',
	fontWeight: 500,
	lineHeight: '1.3em',
	color: Colors.white_a80,
};

export const getMembershipButton: SxProps<Theme> = {
	fontFamily: 'Integral CF, sans-serif',
	fontSize: '13px',
	fontWeight: 600,
	textTransform: 'uppercase',
	color: Colors.white,
};
